import { Route } from '@angular/router';
import { AppComponent } from './app.component';
import { StepWrapperComponent } from './components/step-wrapper/step-wrapper.component';
import { courseStepRoute } from './components/steps/course-step/course-step.definition';
import { extrasStepRoute } from './components/steps/extras-step/extras-step.definition';
import { applicantStepRoute } from './components/steps/applicant-step/applicant-step.definition';
import { quoteStepRoute } from './components/steps/quote-step/quote-step.definition';
import { bookingStepRoute } from './components/steps/booking-step/booking-step.definition';
import { confirmationStepRoute } from './components/steps/confirmation-step/confirmation-step.definition';
import { paymentStepRoute } from './components/steps/payment-step/payment-step.definition';
import { ayaQuoteStepRoute } from './components/steps/aya-quote-step/aya-quote-step.definition';
import { currentStepGuard, rootRedirectGuard } from './guards';

export const appRoutes: Route[] = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [rootRedirectGuard],
        component: StepWrapperComponent,
      },
      {
        path: '',
        component: StepWrapperComponent,
        canActivate: [currentStepGuard],
        children: [
          courseStepRoute,
          extrasStepRoute,
          applicantStepRoute,
          quoteStepRoute,
          ayaQuoteStepRoute,
          bookingStepRoute,
          confirmationStepRoute,
          paymentStepRoute,
        ],
      },
    ],
  },
];
